var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIos14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160.81 139.5",
    style: {
      enableBackground: "new 0 0 160.81 139.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#path1073_1_);}\n\t.st1{fill:url(#path1075_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "text835_2_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path1073_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -72.782,
    y1: 382.0786,
    x2: -37.1412,
    y2: 346.8244,
    gradientTransform: "matrix(2.8346 0 0 -2.8346 212.9895 1120.6023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5AE22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5343,
    style: {
      stopColor: "#E2323E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B5B9B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1073_2_",
    className: "st0",
    d: "M34.6,133.37c0,3.72,2.01,6.14,5.43,6.14c3.52,0,5.43-2.41,5.43-6.14V8.15 c0-4.53-2.92-7.54-7.14-7.54c-2.51,0-4.63,1.01-8.55,3.82L3.92,22.93C1.21,24.84,0,26.55,0,28.56c0,2.41,1.91,4.63,4.53,4.63 c1.41,0,2.72-0.5,4.43-1.71L34,13.78h0.6L34.6,133.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path1075_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -59.0836,
    y1: 395.9272,
    x2: -23.4428,
    y2: 360.673,
    gradientTransform: "matrix(2.8346 0 0 -2.8346 212.9895 1120.6023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5AE22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5343,
    style: {
      stopColor: "#E2323E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B5B9B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1075_2_",
    className: "st1",
    d: "M129.53,133.57c0,3.72,1.71,5.93,5.23,5.93c3.52,0,5.23-2.21,5.23-5.93v-27.06h14.99 c3.72,0,5.83-1.91,5.83-4.93c0-3.22-2.21-4.93-5.83-4.93h-14.99V9.86c0-6.44-3.42-9.86-8.95-9.86c-4.53,0-7.24,2.11-11.06,7.54 C101.27,34.7,80.55,65.17,66.47,89.92c-2.31,4.12-3.62,6.74-3.62,9.45c0,3.92,2.92,7.14,8.35,7.14h58.34L129.53,133.57z  M73.81,96.66v-0.6c14.79-25.35,38.72-61.45,55.22-84.89h0.5v85.49L73.81,96.66z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos14);
export default __webpack_public_path__ + "static/media/ios14.9ccd2114186562a4fb3ce05fdc644ad4.svg";
export { ForwardRef as ReactComponent };